import { LabelShowingResults } from '@/components/common';
import { Input } from '@/components/form';
import Icons from '@/const/icons';
import { useFilters } from '@/hooks';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { ActionRequiredTasksFilter } from './ActionRequiredTasksFilter';

interface ActionRequiredHeaderProps {
	showingItems: number;
	totalItems: number;
}

export const ActionRequiredHeader: React.FC<ActionRequiredHeaderProps> = ({
	showingItems,
	totalItems,
}) => {
	const { register } = useForm();
	const { searchFilter, params } = useFilters();

	return (
		<div className="flex flex-wrap md:flex-nowrap gap-2 items-center gap-x-2 w-full lg:w-auto">
			<Input
				name="search"
				register={register}
				placeholder="Search"
				iconLeft={Icons.search}
				className="w-full lg:w-auto"
				classNameIcon={'!top-[23%] !w-4 !h-4 text-opacity-black'}
				classNameInput="pl-9  xl:w-72 !bg-gray-15 !h-[33px] !m-0 border-none 3xl:!text-sm"
				onChange={({ target }) => searchFilter(target.value)}
			/>
			<div className="flex lg:justify-between md:justify-end justify-between items-center w-full lg:w-auto gap-2">
				<ActionRequiredTasksFilter title="View All" />
				<LabelShowingResults
					total={showingItems}
					totalItems={totalItems}
					labelTotalItems="clients"
					isSearched={params.size > 2} // > 2 since "page" and "tab" params will always exist
				/>
			</div>
		</div>
	);
};
